module.exports = __webpack_public_path__ + "static/media/duo_guru_cover.28f35abf.jpeg";